
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i/[id]",
      function () {
        return require("private-next-pages/i/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i/[id]"])
      });
    }
  